import { useState } from "react";
import posthog from "posthog-js";
import Navbar from "@/components/Navbar";
import SiteFooter from "@/components/SiteFooter";
import { useDocumentMeta } from "@/hooks/useDocumentMeta";
import { useTranslation, useLang } from "@/lib/i18n";

const PrivacyPolicy = () => {
  const t = useTranslation();
  const { lang } = useLang();
  const p = t.legal.privacy;
  const [cookieReset, setCookieReset] = useState(false);

  const handleResetCookies = () => {
    if (typeof posthog.clear_opt_in_out_capturing === "function") {
      posthog.clear_opt_in_out_capturing();
    }
    window.dispatchEvent(new Event("cookie-banner-reopen"));
    setCookieReset(true);
  };

  const canonical =
    lang === "pl"
      ? "https://chrisworkflows.com/pl/privacy"
      : "https://chrisworkflows.com/privacy";

  useDocumentMeta({
    title: p.meta.title,
    description: p.meta.description,
    canonical,
    robots: "index, follow",
    ogTitle: p.meta.title,
    ogDescription: p.meta.description,
    ogImage: "https://chrisworkflows.com/og-image-3.jpg?v=2",
  });

  return (
    <div className="min-h-screen bg-background text-foreground">
      <Navbar />
      <article className="container mx-auto px-6 py-24 max-w-3xl">
        <h1 className="font-display text-4xl sm:text-5xl font-bold tracking-tight mb-3">
          {p.title}
        </h1>
        <p className="font-mono text-xs uppercase tracking-[0.12em] text-muted-foreground mb-8">
          {p.lastUpdated}
        </p>
        <p className="font-body text-base text-foreground/85 mb-12 leading-relaxed">
          {p.intro}
        </p>

        <div className="space-y-10">
          {p.sections.map((s) => (
            <section key={s.heading}>
              <h2 className="font-display text-xl sm:text-2xl font-semibold mb-3">
                {s.heading}
              </h2>
              <p className="font-body text-base text-foreground/80 leading-relaxed">
                {s.body}
              </p>
            </section>
          ))}

          <section className="rounded-2xl border border-border/60 bg-card/40 p-6 sm:p-8">
            <h2 className="font-display text-xl sm:text-2xl font-semibold mb-3">
              {p.cookiePreferences.heading}
            </h2>
            <p className="font-body text-base text-foreground/80 leading-relaxed mb-5">
              {p.cookiePreferences.body}
            </p>
            <button
              type="button"
              onClick={handleResetCookies}
              className="px-5 py-2.5 min-h-[44px] rounded-full border border-border/80 text-foreground/90 font-body font-medium text-sm hover:bg-foreground/5 hover:border-primary/40 transition-colors"
            >
              {p.cookiePreferences.button}
            </button>
            {cookieReset && (
              <p
                role="status"
                aria-live="polite"
                className="mt-4 font-body text-sm text-primary"
              >
                {p.cookiePreferences.statusReset}
              </p>
            )}
          </section>
        </div>
      </article>
      <SiteFooter />
    </div>
  );
};

export default PrivacyPolicy;
